<div class="subBlockContainer" id="customer-form">
  <div>
    <child-header [title]="title" (closeEvent)="close()"></child-header>
    <div class="chid-body">
      <div class="inner-subBlock-wrapper">
        <div [formGroup]="userFormGroup">
          <div class="container" formGroupName="userGroup">
            <label class="title">Customer Details</label>

            <!-- customer details -->
            <div style="margin: 20px 0px 50px 25px;">

              <div class="row">
                <mat-form-field [floatLabel]="'always'" class="col">
                  <input matInput class="companyNameValidate" formControlName="companyNameField" placeholder="Company Name"
                    required>
                </mat-form-field>
                <div class="col" style="width: 557.5;">

                </div>
              </div>
            </div>

            <div style="margin: 20px 0px 50px 25px;">
              <div class="row">
                <mat-form-field [floatLabel]="'always'" class="col">
                  <input id ="addressLine1" matInput class="addressLine1Validate" formControlName="addressLine1Field"
                  (change)="omit_nonprintable_char($event)" placeholder="Address Line 1" required>
                </mat-form-field>
                <mat-form-field [floatLabel]="'always'" class="col">
                  <input id ="addressLine2" matInput class="addressLine2Validate" formControlName="addressLine2Field"
                  (change)="omit_nonprintable_char($event)" placeholder="Address Line 2">
                </mat-form-field>
              </div>
              <div class="row">
                <mat-form-field [floatLabel]="'always'" class="col">
                  <input id ="addressLine3" matInput class="addressLine3Validate" formControlName="addressLine3Field"
                  (change)="omit_nonprintable_char($event)" placeholder="Address Line 3">
                </mat-form-field>
                <mat-form-field [floatLabel]="'always'" class="col">
                  <mat-select class="stateValidate" placeholder="State" formControlName="stateField" required>
                      <mat-option *ngFor="let s of stateList" [value]="s">
                          {{s}}
                      </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="row">
                <mat-form-field [floatLabel]="'always'" class="col">
                  <input matInput class="suburbValidate" #myAutocompleteTriggerSub="matAutocompleteTrigger"
                    (input)="onInputSub($event)" [matAutocomplete]="autoSuburb" formControlName="suburbField"
                    placeholder="Suburb" (keydown.Tab)="chooseAutoCompletSuburb($event)" (suburb)="startFilterSub($event)" 
                    required>
                  <mat-autocomplete #autoSuburb="matAutocomplete">
                    <mat-option *ngFor="let option of filteredSub" [value]="option?.suburb"
                      (click)="chooseAutoComplete(option)">
                      {{option?.suburb+", "+option?.state+", "+option?.postcode}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
                <mat-form-field [floatLabel]="'always'" class="col">
                  <input matInput class="postcodeValidate" #myAutocompleteTriggerPostcode="matAutocompleteTrigger"
                    (input)="onInputPostcode($event)" maxlength="4" (keypress)="isNumberKey($event)"
                    formControlName="postcodeField" (postcode)="startFilterPostcode($event)"
                    (keydown.Tab)="chooseAutoCompletPostcode($event)" [matAutocomplete]="autoPostcode"
                    placeholder="Postcode" required>
                  <mat-autocomplete #autoPostcode="matAutocomplete">
                    <mat-option *ngFor="let option of filteredPostCode" [value]="option?.postcode"
                      (click)="chooseAutoComplete(option)">
                      {{option?.suburb+", "+option?.state+", "+option?.postcode}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </div>

            <label class="title">Contact Details</label>
            <!-- contact section -->
            <div style="margin: 20px 0px 50px 25px;">
              <div class="row">
                <mat-form-field [floatLabel]="'always'" class="col">
                  <input matInput class="firstNameValidate" formControlName="firstNameField" placeholder="First Name"
                    required>
                </mat-form-field>
                <mat-form-field [floatLabel]="'always'" class="col">
                  <input matInput class="lastNameValidate" formControlName="lastNameField" placeholder="Last Name" required>
                </mat-form-field>
              </div>
              <div class="row">
                <mat-form-field [floatLabel]="'always'" class="col">
                  <input matInput class="emailValidate" formControlName="emailField" placeholder="Email Address (Please Use A Current Valid Address)" required>
                </mat-form-field>
                <mat-form-field [floatLabel]="'always'" class="col">
                  <input matInput (keypress)="isNumberKey($event)" class="phoneValidate" formControlName="phoneField"
                    placeholder="Phone" required>
                </mat-form-field>
            </div>
          </div>
        </div>
        <div class="button-center">
          <button
            *ngIf="tenantId == ''"
            class="button button-red button-large"
            [disabled]="!currentUserModel?.hasAdminAccess && !currentUserModel?.hasPurchaseAccess"
            [matTooltipDisabled]="currentUserModel?.hasAdminAccess || currentUserModel?.hasPurchaseAccess"	
            matTooltip="Requires Purchasing Permissions"
            (click)="saveCustomer()"
          > {{ isEditMode ? 'Update' : 'Create' }}</button>
        <loading-screen
          *ngIf="!loadContent"
          [isChildLoader]="true"
          [showBlurTable]="false"
          backDropLeft="0px"
          backDropWidth="100%"
        ></loading-screen>
        </div>
      </div>
    </div>
  </div>
</div>
